module.exports = __webpack_public_path__ + "static/media/clock_icon.dc02e3bb.svg";